module.exports = __webpack_public_path__ + "static/media/figure-8a.f0fc0d21.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/faq/change-batteries/figure-8a.jpg
// module id = 1212
// module chunks = 0